export default "__VITE_ASSET__CijH8Rsc__"